import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    calendarEvents: {
      selectIds: [],
      filters: {},
      selectId: false
    }
  },
  mutations: {
    SET_CALENDAREVENT_SELECT_IDS (store, ids) {
      store.calendarEvents.selectIds = ids
    },
    REMOVE_CALENDAREVENT_SELECT_IDS (store, ids) {
      store.calendarEvents.selectIds = store.calendarEvents.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_CALENDAREVENT_SELECT_ID (store, id) {
      store.calendarEvents.selectId = id
    },
    SET_CALENDAREVENT_FILTERS (store, filters) {
      store.calendarEvents.filters = filters
    }
  },
  getters: {
    getCalendarEvents: (store, getters) => {
      return store.calendarEvents.selectIds.map((id) => {
        return getters['entities/calendarEvents/find'](id)
      })
    },
    getCalendarEventsFilters: (store, getters) => {
      return store.calendarEvents.filters
    },
    getCalendarEvent: (store, getters) => {
      return getters['entities/calendarEvents/find'](store.calendarEvents.selectId) || {}
    }
  },
  actions: {
    /*
    selectCalendarEvents
    */
    selectCalendarEvents ({commit, dispatch, getters, state}, filters) {
      return dispatch('getCalendarEvents', filters)
      .then((response) => {
        commit('SET_CALENDAREVENT_FILTERS', filters)
        commit('SET_CALENDAREVENT_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectCalendarEvents
    */
    refreshSelectCalendarEvents ({commit, dispatch, getters, state}) {
      return dispatch('selectCalendarEvents', getters.getCalendarEventsFilters)
    },
    /*
    selectCalendarEvent
    */
    selectCalendarEvent ({commit, dispatch, getters, state}, id) {
      return dispatch('getCalendarEventById', id)
      .then((response) => {
        commit('SET_CALENDAREVENT_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getCalendarEvents
    */
    getCalendarEvents ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/calendar-events`, {params: filters})
      .then((response) => {
        return dispatch('entities/calendarEvents/insert', {
          data: response.data
        })
        .then((result) => {
          return result.calendarEvents || []
        })
      })
    },
    /*
    getCalendarEventById
    */
    getCalendarEventById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/calendar-events/${id}`)
      .then((response) => {
        return dispatch('entities/calendarEvents/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.calendarEvents[0]
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/CalendarEvent.js